import React from "react";
import './ExamList.scss';
import ExamListState, { ExamListProps, GroupedExams } from "./ExamList.models";
import ExamService from "../../../services/exam/ExamService";
import ExamView from "../exam-view/ExamView";
import equal from 'fast-deep-equal'
import NotFoundExam from "../exam-not-found/NotFoundExam";
import { ExamTypes } from "../../../models/interfaces/exams/exam/ExamTypes";
import ExamTimeViewModal from "../exam-view/exam-time-view-modal/ExamTimeViewModal";
import AuthContext from "../../../contexts/AuthContext";
import RowField from "../../shared/row-field/RowField";
import RowImage from '../../../assest/images/card-image/points-plus-emp.png';

export default class ExamList extends React.PureComponent<ExamListProps, ExamListState> {

    examService: ExamService;
    examTimeViewModal: React.RefObject<ExamTimeViewModal>;
    static contextType = AuthContext

    constructor(props: any) {
        super(props);
        this.examService = new ExamService();
        this.state = {
            exams: [], queryString: {
                title: "",
                isCurrentExams: true,
                orderField: "id",
                orderSort: 0,
                pageSize: 1000,
                pageSkip: 0,
                customFilters: [],
                examType: null,
            }
        };
        this.examTimeViewModal = React.createRef<ExamTimeViewModal>();
    }
    componentDidMount() {
        let self = this;

        self.getExams();
    }

    componentDidUpdate(prevProps: any) {
        let self = this;

        if (!equal(self.props.currentExam, prevProps.currentExam) || !equal(self.props.examTypes, prevProps.examTypes) || !equal(self.props.onlyFutureExams, prevProps.onlyFutureExams))
            self.getExams();
    }

    getExams = () => {
        let self = this;

        self.state.queryString.isCurrentExams = self.props.currentExam;
        self.state.queryString.examType = self.props.examTypes;
        self.state.queryString.onlyFutureExams = self.props.onlyFutureExams;

        self.examService.getCurrentExams(self.state.queryString).then(function (response) {
            var result = response.rows.filter(exam => exam.isActive);

            if (!self.props.currentExam)
                result = response.rows.filter(exam => exam.studentFieldId == self.context.userInformation.education.fieldId)

            if (self.props.currentExam)
                self.setState({ exams: result.filter(exam => exam.examType == ExamTypes.ChapterByChapter) }, () => self.forceUpdate())
            else if (self.props.onlyShowProficiencyTest)
                self.setState({ exams: result.filter(exam => exam.examType === ExamTypes.ProficiencyTest) }, () => self.forceUpdate())
            else if (self.props.examTypes != null || self.props.examTypes != undefined)
                self.setState({ exams: result.filter(exam => exam.examType === self.props.examTypes) }, () => self.forceUpdate())
            else if (self.props.onlyFutureExams)
                self.setState({ exams: result.filter(exam => exam.examType == ExamTypes.ExhaustiveTest && !exam.alreadyJoined) }, () => self.forceUpdate())
        });
    }

    renderGroup = (bases: GroupedExams[]) => {
        return <div>
            {
                bases.map((base: GroupedExams, index: number) => {
                    return <RowField key={index} wordRestrictionLeghnt={16} details={{
                        title: `پایه ${base.studentBaseTitle}`, subTitle: `آزمون های پایه ${base.studentBaseTitle}`,
                        imageSource: RowImage, showButton: true, buttonText: 'مشاهده', buttonStyle: { backgroundColor: 'rgb(68 209 105)', color: '#fff', padding: 0, fontSize: '12px !important' }
                    }} actionButton={{ onClick: () => this.setState({ selectedStudentBaseId: base.studentBaseId }) }} />
                })
            }
        </div>
    }

    renderList = (exams: any) => {
        return <>
            {
                exams.length !== 0 ?
                    <>
                        {
                            exams.map((exam: any) => {
                                return <ExamView openModal={() => this.examTimeViewModal.current?.openModal(exam.id as number, exam.examDateTimeFrom as string, exam.examDateTimeTo as string, exam.examTime as string)} exam={exam} key={exam.id} />
                            })
                        }
                    </> : <NotFoundExam />
            }
        </>
    }

    render(): React.ReactNode {
        let self = this;
        let { exams, selectedStudentBaseId } = self.state;

        let groupedExams: GroupedExams[] = []
        if (this.props.onlyFutureExams)
        {
            groupedExams = exams.reduce((acc, exam) => {
                // اگر آزمون چندین پایه داشته باشد، یک گروه جدا برای آن بساز
                if (exam.studentBaseIdis && exam.studentBaseIdis.length > 1) {
                    const mixedGroup = acc.find(g => g.studentBaseId === "mixed");
                    if (mixedGroup) {
                        mixedGroup.exams.push(exam);
                    } else {
                        acc.push({
                            studentBaseId: "mixed",
                            studentBaseTitle: exam.studentBaseTitles ?? "ترکیبی",
                            exams: [exam]
                        });
                    }
                } else {
                    // آزمون‌هایی که فقط یک پایه دارند را گروه‌بندی کن
                    exam.studentBaseIdis?.forEach(studentBaseId => {
                        const group = acc.find(g => g.studentBaseId === studentBaseId);
                        if (group) {
                            group.exams.push(exam);
                        } else {
                            acc.push({
                                studentBaseId,
                                studentBaseTitle: exam.studentBaseTitles || '',
                                exams: [exam]
                            });
                        }
                    });
                }
                return acc;
            }, [] as GroupedExams[]);            
            
        }

        const filteredExams = this.props.onlyFutureExams ? selectedStudentBaseId ? groupedExams.find(group => group.studentBaseId === selectedStudentBaseId)?.exams || [] : [] : exams;

        return <>
            {(groupedExams.length > 0 && !selectedStudentBaseId) && this.renderGroup(groupedExams)}
            {(this.props.onlyFutureExams && selectedStudentBaseId) && <>
                <RowField key={'back'} wordRestrictionLeghnt={16} wordSubTitleRestrictionLeghnt={16} details={{
                    title: `دسته بندی ها`, subTitle: `بازگشت به دسته بندی ها`,
                    imageSource: RowImage, showButton: true, buttonText: 'مشاهده', buttonStyle: { backgroundColor: 'rgb(68 209 105)', color: '#fff', padding: 0, fontSize: '12px !important' }
                }} actionButton={{ onClick: () => this.setState({ selectedStudentBaseId: undefined }) }} /></>}
            {(!this.props.onlyFutureExams || selectedStudentBaseId) && this.renderList(filteredExams)}
            <ExamTimeViewModal ref={this.examTimeViewModal} />
        </>;
    }
}

